import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import { getClasificadoresEconomicos } from 'api/catalogos';

// eslint-disable-next-line react/prop-types
const ClasificadorEconomico = ({ permission }) => (
  <PlainCRUD
    title="Clasificador Económico"
    permission={permission}
    get={getClasificadoresEconomicos}
    fields={[defaultFields.descripcion]}
    readOnly
  />
);

export default ClasificadorEconomico;
